import { NegativeColors } from '@picsart/design-system/foundation/colors';

import { createUseStyles } from 'react-jss';
import { Spacings } from '@picsart/design-system/foundation/spacings';

const useStyles = createUseStyles(
  {
    root: {
      position: 'relative',
      '@media screen and (min-width: 769px)': {
        paddingInline: Spacings.s12,
      },
    },

    tooltipText: {
      color: NegativeColors.text.default,
    },

    tooltip: {
      display: 'flex',
      justifyContent: 'center',
      position: 'absolute',
      bottom: 0,
      width: '100%',
    },
  },
  {
    name: 'colors-carousel',
  },
);

export default useStyles;
